"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareValues = void 0;
/**
 * Computes truthiness of value comparisons obtained from value filter
 */
function compareValues(actualValue, desiredValue, comparator) {
    switch (comparator) {
        case 'ge':
            return actualValue >= desiredValue;
        case 'gt':
            return actualValue > desiredValue;
        case 'le':
            return actualValue <= desiredValue;
        case 'lt':
            return actualValue < desiredValue;
        case 'eq':
            return actualValue === desiredValue;
        default:
            throw new Error(`Unsupported comparator "${comparator}" when comparing values`);
    }
}
exports.compareValues = compareValues;
//# sourceMappingURL=ValueComparisonHelpers.js.map